import { z } from "zod";

const TransactionSchema = z.object({
  processor: z.string(),
  payee: z.string(),
  amount: z.number(),
  checkDate: z.coerce.date(),
  type: z.string(),
  voided: z.boolean(),
});

const DisbursementHistorySchema = z.object({
  month: z.string(),
  loanAdvances: z.number(),
  equityDisbursements: z.number(),
  loanTransactions: z.number(),
  equityTransactions: z.number(),
  transactions: z.array(TransactionSchema),
});

export const DisbursementHistoryListSchema = z.array(DisbursementHistorySchema);

export type Transaction = z.infer<typeof TransactionSchema>;
export type DisbursementHistory = z.infer<typeof DisbursementHistorySchema>;
